import { createItem, readItems } from "@directus/sdk";
import { useEffect, useState } from "react";
import ModuleContentInterface from "../Interfaces/ModuleContentInterface";
import SlideSwiper from "../Components/Modules/ModuleContent/SlideSwiper";
import ModuleSlideInterface from "../Interfaces/ModuleSlideInterface";
import StyledLink from "../Components/UI/StyledLink";
import { directus } from "../Api/FetchDirectus";
import StyledButton from "../Components/UI/StyledButton";
import { useNavigate } from "react-router-dom";

const TopicPage = () => {
  const navigate = useNavigate();
  const [fileList, setFileList] = useState<
    ModuleContentInterface[] | Record<string, any>[]
  >([]);
  const [slideList, setSlideList] = useState<ModuleSlideInterface[]>([]);
  const scales = JSON.parse(localStorage.getItem("scales") || "{}");
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "[]");
  const moduleInfo = JSON.parse(localStorage.getItem("module_files") || "[]");
  const [topicInfo, setTopicInfo] = useState(
    JSON.parse(localStorage.getItem("topic_files") || "{}") || {}
  );
  const [topicOrder, setTopicOrder] = useState(
    JSON.parse(localStorage.getItem("topic_order") || "0") || 0
  );
  const topicList = JSON.parse(localStorage.getItem("topic_list") || "[]");
  const age = localStorage.getItem("age");
  const gender = localStorage.getItem("gender");
  const activity = localStorage.getItem("activity");
  const position = localStorage.getItem("position");
  const [complete, setComplete] = useState(false);
  const [loader, setLoader] = useState(true);
  const [count, setCount] = useState(1);

  const fetchModuleFiles = async () => {
    try {
      return await directus.request(readItems(`Files`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchModuleSlides = async () => {
    try {
      return await directus.request(readItems(`Slides`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchModuleText = async () => {
    try {
      return await directus.request(readItems(`Text`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  async function fetchFiles() {
    setLoader(true);
    const list = [...(await fetchModuleFiles()), ...(await fetchModuleText())];
    const rawSlides = [...(await fetchModuleSlides())];

    let contentList: ModuleContentInterface[] | Record<string, any> = [];
    let contentSlideList: ModuleSlideInterface[] | Record<string, any> = [];
    if (topicInfo && topicInfo?.files) {
      topicInfo?.files.forEach((item: number) => {
        list.forEach((file) => {
          if (item === file.id) {
            contentList.push(file);
          }
        });
      });
    }
    if (topicInfo && topicInfo?.text) {
      topicInfo?.text.forEach((item: number) => {
        list.forEach((text) => {
          if (item === text.id) {
            contentList.push(text);
          }
        });
      });
    }
    if (topicInfo && topicInfo?.slides) {
      topicInfo?.slides.forEach((item: number) => {
        rawSlides.forEach((slide) => {
          if (item === slide.id) {
            contentSlideList.push(slide);
          }
        });
      });
    }

    setSlideList([
      ...contentSlideList.sort(
        (a: ModuleSlideInterface, b: ModuleSlideInterface) =>
          Number(a.slide_priority) > Number(b.slide_priority) ? 1 : -1
      ),
    ]);

    setFileList([
      ...contentList.sort(
        (a: ModuleContentInterface, b: ModuleContentInterface) =>
          Number(a.priority) < Number(b.priority) ? 1 : -1
      ),
    ]);
    setLoader(false);
  }

  function addToStructure(
    structure: {
      [courseId: string]: {
        [moduleId: string]: string[];
      };
    },
    moduleInfo: {
      course_id: string;
      id: string;
    },
    topicInfo: {
      id: string;
    }
  ) {
    if (!structure[moduleInfo.course_id]) {
      structure[moduleInfo.course_id] = {};
    }

    if (!structure[moduleInfo.course_id][moduleInfo.id]) {
      structure[moduleInfo.course_id][moduleInfo.id] = [];
    }

    if (
      !structure[moduleInfo.course_id][moduleInfo.id].includes(topicInfo.id)
    ) {
      structure[moduleInfo.course_id][moduleInfo.id].push(topicInfo.id);
    }
  }

  let newModule = moduleInfo;

  const onscroll = () => {
    const scrolledTo = window.scrollY + window.innerHeight;
    const threshold = 400;
    const isReachBottom = document.body.scrollHeight - threshold <= scrolledTo;
    if (isReachBottom && count > 0) {
      setCount(0);
      if (!complete) {
        let scalesList =
          JSON.parse(localStorage.getItem("scales") || "{}") || {};
        addToStructure(
          scalesList,
          { course_id: moduleInfo.course_id, id: moduleInfo.id },
          { id: topicInfo.id }
        );

        try {
          directus.request(
            createItem("Course_History", {
              email: localStorage.getItem("email"),
              url: "/modules/module/topic",
              course: localStorage.getItem("courseInfo"),
              module: localStorage.getItem("module_files"),
              topic: localStorage.getItem("topic_files"),
              scales: scalesList,
              completed: localStorage.getItem("completed"),
              certificat_completed: localStorage.getItem(
                "certificat_completed"
              ),
              certificat_link: localStorage.getItem("certificat_link"),
              date: JSON.stringify(new Date()),
              my_courses: localStorage.getItem("my_courses"),
              active_course: localStorage.getItem("active_course"),
              form: JSON.stringify({
                age: age,
                gender: gender,
                activity: activity,
                position: position,
              }),
            })
          );
        } catch (error: any) {
          sessionStorage.removeItem("token");
          navigate("/");
        }

        localStorage.setItem("scales", JSON.stringify(scalesList));
        if (newModule["scale"]) {
          newModule["scale"] = newModule["scale"] + 1;
        } else {
          newModule["scale"] = 1;
        }

        localStorage.setItem("module_files", JSON.stringify(newModule));
      }
    }
  };

  useEffect(() => {
    if (
      scales &&
      scales[courseInfo.id] &&
      scales[courseInfo.id][moduleInfo.id]
    ) {
      const currentModule = scales[courseInfo.id][moduleInfo.id].find(
        (item: number) => item === topicInfo.id
      );

      if (currentModule) {
        setComplete(true);
      } else {
        setComplete(false);
      }
    }
  }, [topicInfo.id]);

  useEffect(() => {
    window.addEventListener("scroll", onscroll);
    return () => {
      window.removeEventListener("scroll", onscroll);
    };
  }, [count, complete]);

  useEffect(() => {
    fetchFiles();

    let sortedList = fileList;

    sortedList.sort((a, b) => (a.priority > b.priority ? 1 : -1));

    setFileList(sortedList);
  }, [topicInfo]);

  function nexTopic() {
    setCount(1);
    setTopicOrder(topicOrder + 1);
    window.scrollTo(0, 0);
  }

  function goModule() {
    window.scrollTo(0, 0);

    try {
      directus.request(
        createItem("Course_History", {
          email: localStorage.getItem("email"),
          url: "/modules/module",
          course: localStorage.getItem("courseInfo"),
          module: localStorage.getItem("module_files"),
          scales: localStorage.getItem("scales"),
          completed: localStorage.getItem("completed"),
          certificat_completed: localStorage.getItem("certificat_completed"),
          certificat_link: localStorage.getItem("certificat_link"),
          topic: JSON.stringify(topicList[topicOrder]),
          date: JSON.stringify(new Date()),
          my_courses: localStorage.getItem("my_courses"),
          active_course: localStorage.getItem("active_course"),
          form: JSON.stringify({
            age: age,
            gender: gender,
            activity: activity,
            position: position,
          }),
        })
      );
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
    }

    topicList.length === 1 ? navigate("/modules") : navigate("/modules/module");
  }

  useEffect(() => {
    localStorage.setItem("topic_order", JSON.stringify(topicOrder));

    setTopicInfo(topicList[topicOrder]);
    localStorage.setItem("topic_files", JSON.stringify(topicList[topicOrder]));

    try {
      directus.request(
        createItem("Course_History", {
          email: localStorage.getItem("email"),
          url: "/modules/module/topic",
          course: localStorage.getItem("courseInfo"),
          module: localStorage.getItem("module_files"),
          scales: localStorage.getItem("scales"),
          completed: localStorage.getItem("completed"),
          certificat_completed: localStorage.getItem("certificat_completed"),
          certificat_link: localStorage.getItem("certificat_link"),
          topic: JSON.stringify(topicList[topicOrder]),
          date: JSON.stringify(new Date()),
          my_courses: localStorage.getItem("my_courses"),
          active_course: localStorage.getItem("active_course"),
          form: JSON.stringify({
            age: age,
            gender: gender,
            activity: activity,
            position: position,
          }),
        })
      );

      localStorage.setItem("module_files", JSON.stringify(newModule));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
    }
  }, [topicOrder]);

  return (
    <div className="coursesListPage">
      <div className="headModuleListBlock">
        <div className="headModuleBlock">
          {" "}
          <div className="courseBlockText testBlockText">
            <div>
              <h1>{moduleInfo.module_name}</h1>
              <div className="headCourseBlockDescription">
                {moduleInfo.module_description}
              </div>
            </div>
            <div className="courseInfo">
              <div>
                <p>Тем в модуле: </p>
                <p className="courseInfoContent"> {moduleInfo.topic_count}</p>
              </div>
              {/* <div>
                <p>Всего тестов:</p>
                <p className="courseInfoContent">{moduleInfo.test_count}</p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <h1 className="topicHead">{topicInfo.topic_name}</h1>
      <div className="topicDescription">{topicInfo.topic_description}</div>
      {loader ? (
        <div style={{ minHeight: "200vh" }}></div>
      ) : (
        <div className="moduleFilesContent">
          {slideList.length > 0 &&
            slideList.map((item, index) => (
              <SlideSwiper item={item} index={index} />
            ))}

          {fileList.map((item, index) =>
            item.file_type === 1 ? (
              <div className="moduleFileBox" key={index}>
                <StyledLink
                  text={item.foreword}
                  link={`https://emir.gtsolifk.ru:4443/assets/${item.file}&embedded=true`}
                ></StyledLink>
              </div>
            ) : item.file_type === 3 ? (
              <div className="moduleFileBox" key={index}>
                <h1>{item.foreword}</h1>
                <iframe
                  title="autorVideo"
                  src={item.url}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
              </div>
            ) : item.file_type === 4 ? (
              <div className="moduleFileBox" key={index}>
                <h2>{item.foreword}</h2>{" "}
                <audio
                  controls
                  src={`https://emir.gtsolifk.ru:4443/assets/${item.file}`}
                ></audio>
              </div>
            ) : item.file_type === "text" ? (
              <div className="moduleText" key={index}>
                <h2>{item.header}</h2>
                {item.text_content}
              </div>
            ) : null
          )}
        </div>
      )}
      <div className="topicButtonBox">
        {topicOrder === topicList.length - 1 ? (
          <StyledButton
            text={topicList.length === 1 ? "К СПИСКУ МОДУЛЕЙ" : "К МОДУЛЮ"}
            onClick={goModule}
          />
        ) : (
          <>
            <StyledButton text={"СЛЕДУЮЩАЯ ТЕМА"} onClick={nexTopic} />
            <StyledButton
              text={topicList.length === 1 ? "К СПИСКУ МОДУЛЕЙ" : "К МОДУЛЮ"}
              onClick={goModule}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default TopicPage;
